<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="data"
          :model="data"
          :rules="rules"
          label-width="100px"
          style="width: 100%"
        >
          <!-- 当无上级区域时隐藏上级区域 -->
          <el-form-item label="上级区域" prop="pid" v-if="showRegionTree">
            <treeselect
              :disabled="!IsEdit || isDisable"
              v-model="data.pid"
              :options="regionOptions"
              noResultsText="暂无选择项"
              placeholder="选择上级区域"
            />
          </el-form-item>
          <el-form-item label="区域编号" prop="areaCode">
            <el-input
              v-model="data.areaCode"
              clearable
              disabled
              placeholder="系统自动生成"
            ></el-input>
          </el-form-item>
          <el-form-item label="区域名称" prop="areaName">
            <el-input
              v-model="data.areaName"
              clearable
              :disabled="isDisable"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属景区" prop="scenicId" v-if="!showRegionTree">
            <el-select v-model="data.scenicId" value-key="" placeholder="选择景区" clearable filterable style="width:100%;">
              <el-option v-for="item in scenicList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="来源" prop="sourceBy">
            <el-radio-group v-model="data.sourceBy">
              <el-radio
                v-for="dict in dict.type.integrate_source_by"
                :key="dict.value"
                :label="dict.value"
                disabled
                >{{ dict.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注" prop="areaDesc">
            <el-input
              type="textarea"
              :rows="2"
              v-model="data.areaDesc"
              :disabled="isDisable"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: right">
        <el-button
          type="primary"
          @click="OnConfirm('data')"
          :disabled="isDisable || isDisable"
          >确认</el-button
        >
        <el-button @click="goBack">返回</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {
  getEquipmentAreaById,
  addEquipmentArea,
  updateEquipmentArea,
  listEquipmentAreaTree,
} from "@/api/src/equipmentArea";
import {
  findAllScenic
} from "@/api/src/resourceApi";
export default {
  name: "ZjRegionManagerInfo",
  components: { Treeselect },
  dicts: ["integrate_source_by"],
  props: {
    RegionInfo: {
      default: () => ({}),
      type: Object,
    },
    DrawRegionInfo: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {
      data: {
        areaCode: null,
        areaName: null,
        scenicId:null,
        areaDesc: null,
        id: null,
        sourceBy: null,
      },
      rules: {
        pid: [{ required: true, message: "请选择上级区域", trigger: "change" }],
        // areaCode: [
        //   { required: true, message: "请输入区域编号", trigger: "blur" },
        // ],
        areaName: [
          { required: true, message: "请输入区域名称", trigger: "blur" },
        ],
        sourceBy: [
          { required: true, message: "请选择来源", trigger: "change" },
        ],
      },
      regionOptions: [],
      showRegionTree: false,
      isDisable: false, //防止重复提交
      areaInfo: this.DrawRegionInfo,
      IsEdit: false,
      isDisable: this.$route.query.type == "query",
      scenicList:[]
    };
  },
  created: function () {
    //   this.data = this.RegionInfo;
    // alert(1);
    // this.init();
    this.getRegionTree();
    this.getScenicList();
  },
  mounted: function () {
    // alert(2);
    // this.init();
    this.$nextTick(() => {
      this.init();
    });
 
  },
  watch: {
    $route: function () {
      if (this.$route.query.type == "add") {
        if (this.$route.query.InfoId) {
          this.data.pid = this.$route.query.InfoId;
        }
      }
      if (this.$route.query.isRow == true) {
        this.IsEdit = false;
      } else {
        this.IsEdit = true;
      }
    },
    RegionInfo: {
      // eslint-disable-next-line no-unused-vars
      handler: function (val, oldVal) {
        (this.data = {
          pid: null,
          areaCode: null,
          areaName: null,
          scenicId:null,
          areaDesc: null,
          sourceBy: null,
        }),
          this.init();
      },
      immediate: true,
      deep: true,
    },
    DrawRegionInfo: {
      handler: function (val, oldVal) {
        this.areaInfo = val;
        //this.initArea();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 初始化
    init() {
      this.data = {...this.RegionInfo,scenicId: this.RegionInfo.scenicId === 0 ? null : this.RegionInfo.scenicId};
      // console.log("this.RegionInfo")
      // console.log(this.RegionInfo)
    if (this.$route.query.isRow == true) {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
      if (this.$route.query.type == "add") {
        //默认来源是新增
        this.data.sourceBy = "1";
        if (this.$route.query.InfoId) {
          this.data.pid = this.$route.query.InfoId;
        }
      }
      if (this.data.pid == null) {
        this.showRegionTree = false;
      }else{
        this.showRegionTree = true;
      }
    },
    initArea() {
      this.areaInfo = this.DrawRegionInfo;
    },
    getRegionById(id) {
      getEquipmentAreaById(id).then((response) => {
        if(this.showRegionTree&&response.data&&response.data.scenicId === 0){
          response.data.scenicId = null;
        }
        this.data = response.data;
      });
    },
    getRegionTree() {
      listEquipmentAreaTree().then((response) => {
        this.regionOptions = response.data;
        // if (this.regionOptions && this.regionOptions.length != 0) {
        //   this.showRegionTree = true;
        // } else {
        //   this.showRegionTree = false;
        // }
      });
    },
    getScenicList(){
      findAllScenic().then((response) => {
        this.scenicList = JSON.parse(response.data) || [];
      });

    },
    OnConfirm(formName) {
      this.isDisable = true;
      const that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.areaInfo.length > 0) {
            const Areas = that.areaInfo.map((item, index) => ({
              AreaIndex: index,
              Longitude: item.lng,
              Latitude: item.lat,
            }));

            that.data.coordinate = JSON.stringify(Areas);
          }

          if (this.data.id != null) {
            if (this.data.id === this.data.pid) {
              this.$message({
                type: "warning",
                message: "不能选择本区域作为上级区域",
              });
              return;
            }
            updateEquipmentArea({...this.data, scenicId: this.showRegionTree ? this.data.scenicId || 0 : this.data.scenicId || null})
              .then((response) => {
                this.isDisable = false;

                this.$message({
                  type: "success",
                  message: "修改成功",
                });
                this.goBack();
              })
              .catch((err) => {
                this.isDisable = false;
              });
          } else {
            addEquipmentArea({...this.data, scenicId: this.data.scenicId || 0})
              .then((response) => {
                this.isDisable = false;
                this.$message({
                  type: "success",
                  message: "增加成功",
                });
                this.goBack();
              })
              .catch((err) => {
                this.isDisable = false;
              });
          }
        } else {
          this.isDisable = false;
          return false;
        }
      });
    },
    goBack() {
      this.$router.go(-1); //返回上一层
    },
  },
};
</script>

<style></style>
